import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {HttpClient} from '@angular/common/http';
import {Api} from '../utils';
import {RequestsHandler} from '@services/requests.service';

@Injectable()
export class PackageTemplatesService {
  private resource = 'account/package-templates';

  constructor(
    private http: HttpClient,
    private api: Api,
    private handler: RequestsHandler
  ) {}

  index(): Observable<any> {
    return this.http
      .get(this.api.getUrl(this.resource), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  show(uuid): Observable<any> {
    return this.http
      .get(this.api.getUrl(this.resource + '/' + uuid), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  store(data): Observable<any> {
    return this.http
      .post(this.api.getUrl(this.resource),  JSON.stringify(data), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  update(uuid, data): Observable<any> {
    return this.http
      .put(this.api.getUrl(this.resource + '/' + uuid),  JSON.stringify(data), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }

  destroy(uuid): Observable<any> {
    return this.http
      .delete(this.api.getUrl(this.resource + '/' + uuid), {headers: this.handler.headers()})
      .catch((err: any) => {
        this.handler.handleError(err);
        return Observable.throw(new Error(err));
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/package-templates.service.ts